import { useCallback, useRef, useState } from 'react';

type DebounceOptions = {
  timeout?: number;
  force?: boolean;
};

export function useDebounce<T = string>(initialData: T, timeout = 500) {
  const [debounced, setDebounced] = useState<T>(initialData);
  const timeoutId = useRef<NodeJS.Timeout>();

  const setValue = useCallback(
    (newVal: T, options: DebounceOptions = {}) => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = undefined;
      }
      if (options?.force) {
        setDebounced(newVal);
      } else {
        timeoutId.current = setTimeout(() => {
          setDebounced(newVal);
          timeoutId.current = undefined;
        }, options?.timeout ?? timeout);
      }
    },
    [timeout]
  );

  return [debounced, setValue] as const;
}
